<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="categories" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Categorias</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                v-on="on"
                @click="export_excel(categories)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn @click="estado='novo'" color="primary" fab dark small class="plus-btn mb-2" v-on="on">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="editedItem.g_area_id"
                            :items="areas"
                            item-value="id"
                            item-text="name"
                            label="Área"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.g_category_id" label="Glintt Category ID"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.name" label="Nome"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.title" label="Título"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                              <v-textarea v-model="editedItem.description" label="Descrição"></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.video"
                            label="Video"
                            hint="Apenas para acrescentar/substituir"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.img_1"
                            label="Imagem 1 (Principal)"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.img_2"
                            label="Imagem 2"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="editedItem.img_3"
                            label="Imagem 3"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{categoryMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed class="mr-2" fab dark color="#90A99C" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "Categorias",
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: "ID", align: "start", sortable: true, value: "id" },
      { text: "Glintt Category ID", sortable: true, value: "g_category_id" },
      { text: "Área", value: "area_name" },
      { text: "Nome Categoria", sortable: true, value: "name" },
      { text: "Acções", value: "actions", align: "end", sortable: false }
    ],
    categories: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    estado: "",
    categoryMsg: "",
    createResult: {},
    updateResult: {},

    img_1: [],
    img_2: [],
    img_3: [],
    video: [],
    form_data: new FormData(),
    areas: []

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Categoria" : "Editar Categoria";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this.close()
        this.categoryMsg = ""
        this.form_data = new FormData()
        this.editedItem = {}
        this.img_1 = []
        this.img_2 = []
        this.img_3 = []
        this.video = []
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'categories-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch('collectCategories', this)
      await this.$store.dispatch('collectAreas', this)
    },

    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = "editar";
    },

    async deleteItem(item) {
      if (!confirm("Tem a certeza que quer eliminar esta Categoria?")){
        return
      }
      this.deletedItem = item

      this.deletedItem.status = 0

      await this.$store.dispatch("deleteCategories", this);
      // this.initialize();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.categoryMsg = "A validar...";
      
      delete this.editedItem.area_name
      delete this.editedItem.area_id
      delete this.editedItem.color_code

      let images = ['img_1', 'img_2', 'img_3', 'video']
      for(let i of images) {
        if(typeof this[i].name == 'string') {
          this.editedItem[i] = this[i]
        }
      }
      for(let i of images) {
        if(this.editedItem[i] == 'null' || this.editedItem[i] == undefined || this.editedItem[i] == '') {
          this.editedItem[i] = "null"
        }
      }

      if (this.editedItem.name == "") {
        this.categoryMsg = "Introduza o nome da Categoria";
      } 
      else if (this.editedItem.g_area_id == "") {
        this.categoryMsg = "Selecione a área";
      } 
      else if (this.editedItem.g_category_id == "") {
        this.categoryMsg = "Indique o ID Glintt da Categoria";
      } 
      else if (this.editedItem.title == "") {
        this.categoryMsg = "Indique o título da Categoria";
      } 
      else if (this.editedItem.description == "") {
        this.categoryMsg = "Indique a descrição da Categoria";
      } 
      else if ((this.editedItem.img_1 == "" || typeof this.editedItem.img_1 == 'undefined') && (this.editedItem.video == "" || typeof this.editedItem.video == 'undefined') && this.editedIndex == -1) {
        this.categoryMsg = "Selecione pelo menos a imagem principal ou um video";
      } 
      else {

        var form_data = new FormData();

        Object.keys(this.editedItem).forEach(key => form_data.append(key, this.editedItem[key]));
        this.form_data = form_data

        if (this.editedIndex > -1) {
          await this.$store.dispatch("updateCategories", this)
        } 
        else {
          await this.$store.dispatch("createCategories", this)
        }
      }
    }
  }
};
</script>
